import { useState } from "react";
import { toast } from "sonner";
import { Star, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export const Stars = ({ value, size = "w-4 h-4", testid }) => (
  <span className="inline-flex gap-0.5" dir="ltr" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`${size} ${i <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />)}
  </span>
);

export function RateChat({ chat, L, onRated }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  if (chat.rating) return (
    <div className="px-4 py-3 border-t border-[#EFEBE0] bg-white text-sm flex items-center gap-2" data-testid="support-rating-done">
      <span className="text-slate-500">{L("تقييمك", "Your rating")}:</span><Stars value={chat.rating} />
      {chat.rating_comment && <span className="text-slate-600 truncate">— {chat.rating_comment}</span>}
    </div>
  );
  const submit = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/support/chats/${chat.chat_id}/rate`, { rating, comment }); toast.success(L("شكراً لتقييمك", "Thanks for your rating")); onRated(data); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="px-4 py-4 border-t border-[#EFEBE0] bg-white space-y-3" data-testid="support-rating-card">
      <p className="font-bold text-sm text-center">{L("كيف كانت تجربتك مع خدمة العملاء؟", "How was your support experience?")}</p>
      <div className="flex justify-center gap-2" dir="ltr">
        {[1, 2, 3, 4, 5].map((i) => (
          <button key={i} type="button" onClick={() => setRating(i)} data-testid={`support-rate-star-${i}`} className="transition-transform hover:scale-110">
            <Star className={`w-8 h-8 ${i <= rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
          </button>
        ))}
      </div>
      <textarea value={comment} onChange={(e) => setComment(e.target.value)} maxLength={500} rows={2} placeholder={L("أضف تعليقاً (اختياري)", "Add a comment (optional)")}
        className="w-full rounded-xl border border-[#E7E3D8] px-3 py-2 text-sm outline-none focus:border-[#1A5C3A]" data-testid="support-rate-comment" />
      <button type="button" disabled={!rating || busy} onClick={submit} className="w-full h-11 rounded-xl bg-[#1A5C3A] text-white font-bold disabled:opacity-40 flex items-center justify-center gap-2" data-testid="support-rate-submit">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />}{L("إرسال التقييم", "Submit rating")}
      </button>
    </div>
  );
}
